<template>
	<div class="map-box">
		<div class="map-title" @click="clog">态势五色图</div>
		<div class="header" style="position: relative">
			<!-- <span>{{ false ? "" : "所有单位" }}</span> -->
			<el-popover placement="bottom" width="200" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-checkbox-group :disabled="isSelect" style="max-height: 300px; overflow-y: auto" v-model="params.dangerousCapacityList" @change="handleCheckedCitiesChange">
					<el-checkbox v-for="(item, index) in dangerousCapacityList" :label="index" :key="item">{{ item }}</el-checkbox>
				</el-checkbox-group>
				<span class="flex" slot="reference">{{ false ? "" : "危化品存量" }}<el-image :src="require('@/assets/img/analysis/down.png')" alt=""/></span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<el-popover placement="bottom" width="200" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-checkbox-group :disabled="isSelect" style="max-height: 300px; overflow-y: auto" v-model="params.safeLevelList" @change="handleCheckedCitiesChange">
					<!-- <el-checkbox
            v-for="(item, index) in safeLevelList"
            :label="index"
            :key="item"
            >{{ item+index }}</el-checkbox
          > -->
					<el-checkbox v-for="(item, index) in safeLevelList" :label="item.num" :key="index">{{ item.value }}</el-checkbox>
				</el-checkbox-group>
				<span class="flex" style="justify-content: center" slot="reference">{{ false ? "" : "重点级别" }}<el-image :src="require('@/assets/img/analysis/down.png')" alt=""/></span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<el-popover placement="bottom" width="200" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-tree :data="areaList" :props="defaultProps" show-checkbox :disabled="isSelect" style="max-height: 300px; overflow-y: auto" @check="handleCheckedCitiesChange2">
					<!-- <el-checkbox-group :disabled="isSelect" style="max-height: 300px;overflow-y: auto;" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item, index) in areaList" :label="index" :key="item">{{ item }}</el-checkbox>
        </el-checkbox-group> -->
				</el-tree>
				<!-- <el-checkbox-group :disabled="isSelect" style="max-height: 300px;overflow-y: auto;" v-model="params.areaList" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item, index) in areaList" :label="index" :key="item">{{ item }}</el-checkbox>
        </el-checkbox-group> -->
				<span class="flex" style="justify-content: center" slot="reference"
					>{{ false ? "" : "辖区" }}
					<el-image :src="require('@/assets/img/analysis/down.png')" alt="" />
				</span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<el-popover placement="bottom" width="200" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-checkbox-group :disabled="isSelect" style="max-height: 300px; overflow-y: auto" v-model="params.buildTypeList" @change="handleCheckedCitiesChange" :key="buildTypeKey">
					<el-checkbox v-for="(item, index) in buildTypeList" :label="index" :key="item">{{ item }}</el-checkbox>
				</el-checkbox-group>
				<span class="flex" slot="reference">{{ false ? "" : "建筑类型" }}<el-image :src="require('@/assets/img/analysis/down.png')" alt=""/></span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<el-popover placement="bottom" width="120" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-checkbox-group :disabled="isSelect" style="max-height: 300px; overflow-y: auto" v-model="params.unitNatureList" @change="handleCheckedCitiesChange">
					<el-checkbox v-for="(item, index) in unitNatureList" :label="index" :key="item">{{ item }}</el-checkbox>
				</el-checkbox-group>
				<span class="flex" slot="reference">{{ false ? "" : "建筑性质" }}<el-image :src="require('@/assets/img/analysis/down.png')" alt=""/></span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<el-popover placement="bottom" width="240" trigger="click" :append-to-body="false" :popper-append-to-body="false">
				<el-checkbox-group
					:disabled="isSelect"
					style="
            max-height: 300px;
            overflow: auto;
            display: flex;
            flex-direction: column;
          "
					v-model="params.belongProfessionList"
					@change="handleCheckedCitiesChange"
				>
					<el-checkbox v-for="item in belongProfessionList" :label="item.mcId" :key="item.mcId">{{ item.mcName }}</el-checkbox>
				</el-checkbox-group>
				<span class="flex" slot="reference">{{ false ? "" : "行业分类" }}<el-image :src="require('@/assets/img/analysis/down.png')" alt=""/></span>
				<!-- <el-button >click 激活</el-button> -->
			</el-popover>
			<!-- 重点级别 辖区 建筑类型 建筑性质 行业分类
			<span>{{ false ? "" : "重点级别" }}</span>
			<span>{{ false ? "" : "辖区" }}</span>
			<span>{{ false ? "" : "建筑类型" }}</span>
			<span>{{ false ? "" : "建筑性质" }}</span>
			<span>{{ false ? "" : "行业分类" }}</span> -->
		</div>
		<div
			style="
        position: relative;
        display: flex;
        width: 200px;
        justify-content: flex-end;
      "
		>
			<div class="top-text">
				当前联网单位总数
			</div>
			<!-- <div style="width:100%">
        
      </div> -->
			<div class="count-number">{{ totalNum }}</div>
		</div>
		<!-- 图标 -->
		<div style="position: relative">
			<el-image
				style="
          z-index: 11;
          position: absolute;
          right: 5px;
          top: 15px;
          width: 16px;
          height: 16px;
        "
				:src="require('@/assets/img/analysis/tab-icon.png')"
				@click="change"
			></el-image>
			<el-button
				type="success"
				@click="resetMap"
				plain
				round
				size="mini"
				style="position: absolute;
          right: 30px;
          top: 10px;
          background-color:transparent"
				>地图重置</el-button
			>
		</div>

		<!-- v-if="changeJinanQingdao == 1" -->
		<div class="flex1 mapCont" id="main" v-if="changeJinanQingdao == 1">
			<div style="width: 100%; height: 79%; margin-top: 100px" ref="mapCharts"></div>
		</div>
		<div class="flex1 mapCont" id="main" v-else>
			<div style="width: 100%; height: 79%; margin-top: 100px" ref="mapChartsJinan"></div>
		</div>
	</div>
</template>

<script>
	// import dashboard from "./components/dashboard.vue";
	import MapQingdao from "../api/map.json";
	import MapJinan from "@/views/home/api/map.json";
	import * as echarts from "echarts";
	import { mapOption, firePieOption, mapOption1, jinanMapOption, jinanMapOption1 } from "../api/echartsOptions.js";
	export default {
		// components: { dashboard },
		data() {
			return {
				changeJinanQingdao: 0,
				isSelect: false,
				sessionFlag: false,
				params: {
					areaList: [],
					belongProfessionList: [],
					buildTypeHeight: "",
					buildTypeList: [],
					dangerousCapacityList: [],
					safeLevelList: [],
					unitNatureList: [],
				},
				areaList: [],
				belongProfessionList: [],
				buildTypeHeight: {},
				buildTypeList: {
					1: "1类高层",
					2: "2类高层",
					3: "单多层建筑",
					4: "高度>100m",
					5: "高度>250m",
				},
				dangerousCapacityList: {
					267: "1000m³以下",
					268: "1000-10000m³",
					269: "10000m³以上",
				},
				// safeLevelList: {
				//   40: "火灾高危单位",
				//   41: "重点单位",
				//   39: "一般单位",
				//   42: "九小场所",
				// },
				safeLevelList: [
					{ num: 40, value: "火灾高危单位" },
					{ num: 41, value: "重点单位" },
					{ num: 39, value: "一般单位" },
					{ num: 42, value: "九小场所" },
				],
				unitNatureList: { 245: "工业", 252: "公共建筑", 253: "住宅建筑" },
				buildTypeKey: 0,
				mapCharts: null,
				mapChartsJinan: null,
				iconList: [
					require("@/assets/img/analysis/green-icon.png"),
					require("@/assets/img/analysis/blue-icon.png"),
					require("@/assets/img/analysis/yellow-icon.png"),
					require("@/assets/img/analysis/brown-icon.png"),
					require("@/assets/img/analysis/red-icon.png"),
				],
				localArea: [],
				isFlag: true,
				totalNum: 0,
				defaultProps: {
					children: "child",
					label: "name",
				},
			};
		},
		props: ["outParams"],
		watch: {
			// shdata: {
			//   handler(n, o) {
			//     this.initCharts();
			//     this.$nextTick(() => {
			//       this.getData();
			//     });
			//   },
			//   deep:true
			// },
			"params.buildTypeList": {
				handler: function(newV, oldV) {
					let newBuildType;
					newBuildType = newV.find((item1) => !oldV.some((item2) => item1 == item2));

					this.params.buildTypeHeight = newV.find((item) => this.judgingRadio(item));
					if (oldV?.some((item) => this.judgingRadio(item)) && this.judgingRadio(newBuildType)) {
						this.$message.warning("已选择建筑高度");
						this.params.buildTypeList = [...oldV];
						this.buildTypeKey++;
						return;
					}
				},
			},
			params: {
				handler: function(newV, oldV) {
					// console.log('触发监听');
					if (this.isSelect) {
						this.$message.warning("请稍后再试!");
						return;
					}
					this.getData();
				},
				deep: true, //深度侦听
				// immediate: true, //立即执行(页面刚进来也会执行)
			},
		},
		created() {
			this.changeJinanQingdao = this.$store.state.user.userInfo.region;
		},
		mounted() {
			// this.shdata
			this.initCharts();
			this.getSituationFiveColorMapCode();
			this.getAreaByUserId();
			this.$nextTick(() => {
				this.getData();
			});
		},
		methods: {
			quan(e) {
				log(e, 67878687);
			},
			// 判断是否为单选
			judgingRadio(val) {
				return [4, 5].some((item) => item == val);
			},
			getAreaByUserId() {
				this.$get("things/dataAnalysis/selectAreaByUserId").then((res) => {
					// log(res);
					this.localArea = res.data;
				});
			},
			findcode(val) {
				return this.localArea.find((item) => item.name == val)?.code;
			},
			getData() {
				this.isSelect = true;

				this.$post("things/dataAnalysis/situationFiveColorMap", this.params).then((res) => {
					// log(res, 3333);
					this.totalNum = res.data.length;
					this.isSelect = false;

					// log(this.changeJinanQingdao, 111111111111111111111111);
					if (this.changeJinanQingdao == 1) {
						// log("青岛");
						mapOption.series[0].markPoint.data =
							res.data.map((item) => {
								return {
									ccompanyNum: item.ccompanyNum,
									name: item.cname,
									coord: [item.lon, item.lat],
									symbol: "image://" + this.iconList[item.scoreNum - 1],
									// symbol: "pin",
									symbolSize: [15, 20], // 标记大小
									symbolRotate: 0, // 旋转角度
									symbolOffset: [0, 0], // 偏移量
									label: "", // 标记的文本
								};
							}) || {};
						// setTimeout(() => {
						//   this.mapCharts.setOption(mapOption);
						// });
						setTimeout(() => {
							this.mapCharts.setOption(mapOption);
						});
					} else {
						log("济南");
						jinanMapOption.series[0].markPoint.data =
							res.data.map((item) => {
								return {
									ccompanyNum: item.ccompanyNum,
									name: item.cname,
									coord: [item.lon, item.lat],
									symbol: "image://" + this.iconList[item.scoreNum - 1],
									// symbol: "pin",
									symbolSize: [15, 20], // 标记大小
									symbolRotate: 0, // 旋转角度
									symbolOffset: [0, 0], // 偏移量
									label: "", // 标记的文本
								};
							}) || {};
						setTimeout(() => {
							this.mapChartsJinan.setOption(jinanMapOption);
						});
					}

					// setTimeout(() => {
					//   this.mapCharts.setOption(mapOption);
					// });
				});
			},
			getSituationFiveColorMapCode() {
				this.$post("things/dataAnalysis/situationFiveColorMapCode").then((res) => {
					// console.log(res, 111111);
					this.areaList = res.data.areaList;
					// this.params.areaList = this.areaList;
					// console.log(this.areaList, "areaList");
					// this.areaList = {};
					//  for(let key in this.areaList){
					//       console.log(key);
					//       this.areaList[key].label=this.areaList[key].name
					//       for (let index in this.areaList[key].child) {
					//         this.areaList[key].child[index].label=this.areaList[key].child[index].name
					//       }
					//  }
					this.belongProfessionList = res.data.mapCodeList;
					// .map((item) => {
					//   return item.mcName;
					// });

					// console.log(res.data.mapCodeList, 22222222);
				});
			},
			change() {
				this.$emit("change-type");

				// mapOption.dispatchAction({
				//   type: "geoUnSelect",
				//   geoIndex: 0,
				//   name: "SITQD",
				// });#00000000
			},
			clog() {
				// console.log(this.params);
			},
			handleCheckedCitiesChange(val) {
				// console.log(val, 111111111111111111111);
			},
			resetMap() {
				this.$emit("mapOrigin", this.isFlag);
				// 五色图下面数据重置
				this.areaList = [];
				this.getSituationFiveColorMapCode();
				this.params = {
					areaList: [],
					belongProfessionList: [],
					buildTypeHeight: "",
					buildTypeList: [],
					dangerousCapacityList: [],
					safeLevelList: [],
					unitNatureList: [],
				};

				if (this.changeJinanQingdao == 1) {
					mapOption.series[0].data = [];
					this.mapCharts.setOption(mapOption, {
						notMerge: true,
					});
				} else {
					jinanMapOption.series[0].data = [];
					this.mapChartsJinan.setOption(jinanMapOption, {
						notMerge: true,
					});
				}
				// mapOption1.series[0].data = [];

				// jinanMapOption1.series[0].data = [];
				// // console.log(this.mapCharts.getOption());

				// this.mapCharts.setOption(mapOption1, {
				//   notMerge: true,
				// });

				// this.mapChartsJinan.setOption(jinanMapOption1, {
				//   notMerge: true,
				// });
			},
			initCharts(data) {
				// 地图注册，第一个参数的名字必须和option.geo.map一致mapChartsJinan
				// console.log(mapOption, MapJinan, "map charts");
				// this.changeJinanQingdao = 1;

				if (this.changeJinanQingdao == 1) {
					this.mapCharts = echarts.init(this.$refs["mapCharts"]);
					echarts.registerMap("SITQD", MapQingdao);
					this.mapCharts.setOption(mapOption);
					this.mapCharts.on("georoam", (map) => {});
					this.mapCharts.on("mouseover", function(params) {});
					window.isBlank = true;

					this.mapCharts.on("click", (param) => {
						window.isBlank = false;

						firePieOption.title[0].text = param.name + "消防评估汇总图";
						// console.log(param.name);

						mapOption.series[0].data = [{ name: param.name, selected: true }];

						let code = this.findcode(param.name);
						if (code) {
							this.outParams.carea = code;
						} else if (param.data?.ccompanyNum) {
							this.outParams.ccompanyNum = param.data.ccompanyNum;
						}

						this.mapCharts.setOption(mapOption);

						// this.mapCharts.setOption(mapOption);
					});
					var oDiv = document.querySelector("#main>div");
					oDiv.onclick = () => {
						if (window.isBlank) {
							// firePieOption.title[0].text='青岛消防评估汇总图'
							this.mapCharts = echarts.init(this.$refs["mapCharts"]);
							this.isSelect = true;
							// 标点的
							this.$post("things/dataAnalysis/situationFiveColorMap", this.params).then((res) => {
								this.isSelect = false;

								mapOption1.series[0].markPoint.data =
									res.data.map((item) => {
										return {
											ccompanyNum: item.ccompanyNum,
											name: item.cname,
											coord: [item.lon, item.lat],
											symbol: "image://" + this.iconList[item.scoreNum - 1],
											// symbol: "pin",
											symbolSize: [15, 20], // 标记大小
											symbolRotate: 0, // 旋转角度
											symbolOffset: [0, 0], // 偏移量
											label: "", // 标记的文本
										};
									}) || {};

								setTimeout(() => {
									this.mapCharts.setOption(mapOption1);
								});
							});

							this.$emit("mapOrigin", this.isFlag);

							this.mapCharts.setOption(mapOption1);
						}
						window.isBlank = true;
					};
				} else {
					this.mapChartsJinan = echarts.init(this.$refs["mapChartsJinan"]);
					// console.log(4444);
					firePieOption.title[0].text = "济南消防评估汇总图";
					echarts.registerMap("QD", MapJinan);
					this.mapChartsJinan.setOption(jinanMapOption);
					this.mapChartsJinan.on("georoam", (map) => {});
					this.mapChartsJinan.on("mouseover", function(params) {});

					window.isBlank = true;

					this.mapChartsJinan.on("click", (param) => {
						window.isBlank = false;

						firePieOption.title[0].text = param.name + "消防评估汇总图";
						// console.log(param.name);

						jinanMapOption.series[0].data = [{ name: param.name, selected: true }];

						let code = this.findcode(param.name);
						if (code) {
							this.outParams.carea = code;
						} else if (param.data?.ccompanyNum) {
							this.outParams.ccompanyNum = param.data.ccompanyNum;
						}

						this.mapChartsJinan.setOption(jinanMapOption);

						// this.mapCharts.setOption(mapOption);
					});
					var oDiv = document.querySelector("#main>div");
					oDiv.onclick = () => {
						if (window.isBlank) {
							this.mapChartsJinan = echarts.init(this.$refs["mapChartsJinan"]);
							this.isSelect = true;
							// 标点的
							this.$post("things/dataAnalysis/situationFiveColorMap", this.params).then((res) => {
								this.isSelect = false;

								jinanMapOption1.series[0].markPoint.data =
									res.data.map((item) => {
										return {
											ccompanyNum: item.ccompanyNum,
											name: item.cname,
											coord: [item.lon, item.lat],
											symbol: "image://" + this.iconList[item.scoreNum - 1],
											// symbol: "pin",
											symbolSize: [15, 20], // 标记大小
											symbolRotate: 0, // 旋转角度
											symbolOffset: [0, 0], // 偏移量
											label: "", // 标记的文本
										};
									}) || {};

								setTimeout(() => {
									this.mapChartsJinan.setOption(jinanMapOption1);
								});
							});
							this.$emit("mapOrigin", this.isFlag);
							this.mapChartsJinan.setOption(jinanMapOption1);
						}
						window.isBlank = true;
					};
				}

				// echarts.registerMap("SITQD", MapQingdao);

				// if (this.changeJinanQingdao == 1) {
				//   // this.$echarts.dispose(this.$refs["mapCharts"]);
				//   log("青岛坐标");
				//   this.mapCharts = echarts.init(this.$refs["mapCharts"]);
				//   echarts.registerMap("SITQD", MapQingdao);
				//   this.mapCharts.on("georoam", (map) => {});
				//   this.mapCharts.setOption(mapOption);
				//   this.mapCharts.on("mouseover", function (params) {});
				// } else {
				//   // this.$echarts.dispose(this.$refs["mapChartsJinan"]);

				//   this.mapChartsJinan = echarts.init(this.$refs["mapChartsJinan"]);

				//   echarts.registerMap("QD", MapJinan);
				//   this.mapChartsJinan.on("georoam", (map) => {});
				//   this.mapChartsJinan.setOption(jinanMap);
				//   this.mapChartsJinan.on("mouseover", function (params) {});
				// }
			},

			handleCheckedCitiesChange2(data, checked) {
				console.log(data, checked);
				const checkList = checked.checkedNodes;
				this.params.areaList = [];
				checkList.forEach((item) => {
					if (item.children) {
						return;
					}
					this.params.areaList.push(item.code);
				});
				// console.log("current change", data, checkList);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.map-title {
		/** 文本1 */
		font-size: 37px;
		font-weight: 900;
		text-align: center;
		color: rgba(236, 249, 255, 1);
	}
	.header {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		border-radius: 2px 2px 15px 15px;
		background: rgba(204, 204, 204, 0.22);
		padding: 6px 12px;
		border: 1px solid rgba(176, 176, 176, 0.36);
		// 取消多于滚动条
		*::-webkit-scrollbar {
			display: none;
		}
		span {
			text-align: center;
		}
	}
	.map-box {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.top-text {
		position: absolute;
		/** 文本1 */
		font-size: 20px;
		font-weight: 500;

		color: rgba(236, 249, 255, 1);
	}
	.count-number {
		position: absolute;
		top: 30px;
		/** 文本1 */
		font-size: 36px;
		font-weight: 700;

		color: rgba(255, 159, 46, 1);
	}
	.mapCont {
		// flex: 1;
		display: flex;
		height: 100%;
	}
</style>
